import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { formatRegionMoney } from '@/lib/regionConfig';
import Panel from './Panel';

const PendingInvoicesPanel = ({ invoices, regionConfig, onNavigate }) => (
  <Panel title="Pending Invoices" onViewAll={() => onNavigate('/invoices')} testId="pending-invoices">
    {invoices.length === 0 ? (
      <div className="text-center py-6" data-testid="empty-invoices">
        <FileText className="w-8 h-8 mx-auto mb-3 text-muted-foreground" />
        <p className="text-sm text-muted-foreground">No pending invoices</p>
      </div>
    ) : (
      <ul className="divide-y divide-border">
        {invoices.slice(0, 3).map((invoice) => (
          <li key={invoice.id} className="flex items-center justify-between gap-3 py-3 first:pt-0 last:pb-0">
            <div className="min-w-0">
              <p className="text-sm font-mono">{invoice.id}</p>
              <p className="text-xs text-muted-foreground truncate">{invoice.company}</p>
            </div>
            <span className={`font-mono text-sm ${invoice.status === 'overdue' ? 'text-error' : ''}`}>
              {formatRegionMoney(invoice.amount, regionConfig)}
            </span>
            <Button size="sm" variant="outline" className="shrink-0" onClick={() => onNavigate('/invoices')}>
              Pay Now
            </Button>
          </li>
        ))}
      </ul>
    )}
  </Panel>
);

export default PendingInvoicesPanel;
